import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Button from '../../components/Button/Button';
import styles from './Revenue.module.css';

const Revenue = () => {
  const headerActions = (
    <Link to="/edit-pricing">
      <Button variant="primary">Edit pricing</Button>
    </Link>
  );

  return (
    <>
      <PageHeader
        title="Revenue & plans"
        subtitle="Subscriptions, service fees and plan pricing."
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Revenue · Sep" value="₹4.1L" subtext="+21% vs Aug" isGreen />
        <MetricCard label="Subscription MRR" value="₹1.5L" subtext="38 paid accounts" />
        <MetricCard label="Free → Pro conversion" value="6.8%" subtext="last 90 days" />
        <MetricCard label="Avg. revenue per account" value="₹2,770" subtext="per month" />
      </MetricRow>

      <div className={styles.mainGrid}>
        <section className={styles.card}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>Plans</h2>
            <Link to="/edit-pricing" className={styles.editLink}>
              Edit →
            </Link>
          </div>

          <div className={styles.tableWrapper}>
            <div className={styles.tableHeader}>
              <div>Plan</div>
              <div>Monthly</div>
              <div>Yearly (per mo)</div>
              <div>Service fee</div>
              <div>Seats</div>
              <div>Live studies</div>
              <div>Accounts</div>
            </div>

            <div className={styles.tableRow}>
              <div><span className={styles.planName}>Free</span></div>
              <div>₹0</div>
              <div>—</div>
              <div>20%</div>
              <div>1</div>
              <div>3</div>
              <div>110</div>
            </div>

            <div className={styles.tableRow}>
              <div><span className={styles.planName}>Pro</span></div>
              <div>₹4,999</div>
              <div>₹3,999</div>
              <div>10%</div>
              <div>3</div>
              <div>10</div>
              <div>32</div>
            </div>

            <div className={styles.tableRow}>
              <div><span className={styles.planName}>Agency</span></div>
              <div>From ₹14,999</div>
              <div>Custom</div>
              <div>5–8%</div>
              <div>Unlimited</div>
              <div>Unlimited</div>
              <div>6</div>
            </div>
          </div>
        </section>

        <section className={`${styles.card} ${styles.mixSection}`}>
          <h2 className={styles.cardTitle}>Revenue mix · Sep</h2>

          <div className={styles.mixItem}>
            <div className={styles.mixHeader}>
              <span className={styles.mixLabel}>Service fees on incentives</span>
              <span className={styles.mixValue}>₹2.6L · 63%</span>
            </div>
            <div className={styles.progressTrack}>
              <div className={`${styles.progressBar} ${styles.blueBar}`} style={{ width: '63%' }}></div>
            </div>
          </div>

          <div className={styles.mixItem}>
            <div className={styles.mixHeader}>
              <span className={styles.mixLabel}>Pro subscriptions</span>
              <span className={styles.mixValue}>₹1.1L · 27%</span>
            </div>
            <div className={styles.progressTrack}>
              <div className={`${styles.progressBar} ${styles.darkBlueBar}`} style={{ width: '27%' }}></div>
            </div>
          </div>

          <div className={styles.mixItem}>
            <div className={styles.mixHeader}>
              <span className={styles.mixLabel}>Agency subscriptions</span>
              <span className={styles.mixValue}>₹0.4L · 10%</span>
            </div>
            <div className={styles.progressTrack}>
              <div className={`${styles.progressBar} ${styles.purpleBar}`} style={{ width: '10%' }}></div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Revenue;
